// initial state
const state = () => ({
  width_1: [],
  formatter_width_1: '{x}"',
  active_width_1: {},
  active_label_width_1: "Left Side",
  default_width_1: {},
  width_2: [],
  formatter_width_2: '{x}"',
  active_width_2: {},
  default_width_2: {},
  active_label_width_2: "Right Side",
  width_3: [],
  formatter_width_3: '{x}"',
  active_width_3: {},
  active_label_width_3: "Center",
  depth: [],
  formatter_depth: '{x}" Deep',
  default_depth: {},
  activeDepth: {},
  bed_size:[],
  formatter_bed_size: '{x}',
  default_bed_size: {},
  active_bed_size: {},
  active_label_bed_size: "Size",

});

// getters
const getters = {
  getSizes: (state) => {
    return {
      width_1: state.width_1,
      width_2: state.width_2,
      width_3: state.width_3,
      depth: state.depth,
      bed_size: state.bed_size
    };
  },
  getSize: (state) => (key, value) => {
    if (state[key]) {
      return state[key].find((sizeOption) => sizeOption == value);
    }
    return undefined;
  },
  getActiveSize: (state) => (key) => {
    if (state[`active_${key}`]) {
      return state[`active_${key}`];
    }
    return undefined;
  },
  getActiveSizes: (state) => () => {
    return {
      "width_1":state.active_width_1,
      "width_2":state.active_width_2,
      "width_3":state.active_width_3,
      "bed_size":state.active_bed_size,
      "depth":state.active_depth,
    };
  },
  getDefaultSize: (state) => (key) => {
    if (state[`default_${key}`]) {
      return state[`default_${key}`];
    }
    return undefined;
  },
  getFormatter: (state) => (key) => {
    if (state[`formatter_${key}`]) {
      return state[`formatter_${key}`];
    }
    return undefined;
  },
  getActiveLabel: (state) => (key) => {
    if (state[`active_label_${key}`]) {
      return state[`active_label_${key}`];
    }
    return undefined;
  },
};

// actions
const actions = {
  setSizes({ commit }, sizes) {
    commit("setSizes", { sizes });
  },
  activateSize({ commit }, { size, key }) {
    commit("activateSize", { size, key: `active_${key}` });
  },
  setDefaultSize({ commit }, { size, key }) {
    
    commit("setDefaultSize", { size, key: `default_${key}` });
  },
  setActiveLabel({ commit }, { label, key }) {
    commit("setActiveLabel", { label, key: `active_label_${key}` });
  },
};

// mutations
const mutations = {
  setSizes(state, { sizes }) {
    Object.keys(sizes).forEach((key) => {
      if (sizes[key].length) {
        const sizeCopy = [...sizes[key]];
        sizeCopy.sort((a, b) => {
          const aInt = parseInt(a);
          const bInt = parseInt(b);
          return aInt < bInt ? -1 : bInt === aInt ? 0 : 1;
        });
        state[key] = sizeCopy;
      }
    });
  },
  activateSize(state, { size, key }) {
    if (key in state) {
      state[key] = size;
    }
  },
  setDefaultSize(state, { size, key }) {
    if (key in state) {
      state[key] = size;
    }
  },
  setActiveLabel(state, { label, key }) {
    if (key in state) {
      state[key] = label;
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
